import {
  AddLeaveOfAbsenceToLearnerDocument,
  DeferralReason,
} from '@sandtech-hub-monorepo/ehub-client';
import { useMutation } from '@apollo/client';
import { Button } from '@sandtech-hub-monorepo/ui-kit';
import { Loader2Icon } from 'lucide-react';
import { ReactComponent as PauseIcon } from '../../../assets/Icons/pause-icon.svg';
import React from 'react';
import { ProgramEnrollment } from './SelectProgram';

interface ConfirmProps {
  description: string;
  reason: DeferralReason;
  onCancel: () => void;
  afterConfirm: () => void;
  alreadyDeferred: (string | undefined)[];
  programEnrollment: ProgramEnrollment;
}

export const PauseProgramConfirmation = ({
  description,
  reason,
  onCancel,
  afterConfirm,
  alreadyDeferred,
  programEnrollment,
}: ConfirmProps) => {
  const [mutate, { loading }] = useMutation(
    AddLeaveOfAbsenceToLearnerDocument,
    {
      variables: {
        input: {
          programEnrollmentId: programEnrollment.id,
          leaveOfAbsenceReason: reason,
          leaveOfAbsenceDescription: description || undefined,
        },
      },
      onCompleted: () => {
        afterConfirm();
      },
    }
  );

  return (
    <div className="max-w-[620px]">
      <div className="px-0 sm:px-16">
        <div className="flex flex-col items-center text-center gap-2">
          <div
            className={`p-6 bg-primary/20 rounded-full text-primary mx-auto mb-2`}
          >
            <PauseIcon height="48" width="48" />
          </div>
          <h2 className={`text-primary font-semibold sm:text-2xl text-xl`}>
            Please confirm
          </h2>
          <div className="text-xl">
            You are opting to pause your ALX Program. This includes the
            following courses:
          </div>
        </div>
        <div className="border-b-primary/20 my-8 pb-8 border-b">
          <div className="text-center flex flex-col gap-2 mb-8">
            {programEnrollment.plannedCourses
              .filter(
                ({ enrollment }) =>
                  !alreadyDeferred.includes(enrollment?.currentClass?.id)
              )
              .map((course) => (
                <b key={course.id}>{course.details.name}</b>
              ))}
          </div>
          <div className="text-center">
            You will be enrolled in the next available class and will resume the
            program, but all current course content will need to be restarted.
          </div>
        </div>
        <div className="flex gap-6 justify-center">
          <Button onClick={() => mutate()} disabled={loading}>
            {loading ? <Loader2Icon className="animate-spin" /> : 'Confirm'}
          </Button>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};
